<div class="pagination-total">Anzahl: {{total}}</div>
